import { useState } from "react";
import { Column } from "../../../../core/components/Column"
import { DropDown } from "../../../../core/components/DropDown";
import { Row } from "../../../../core/components/Row"
import { TextComponent } from "../../../../core/components/TextComponent";
import { ArrowDown2 } from "../../../../core/icons/ArrowDown";
import { Option } from "../../../../core/icons/Option";
import { ModalSimple } from "../../../../core/components/Modal";
import { XCloseBG, XCloseBin } from "../../../../core/icons/XClose";
import { ReportUser } from "../../../../core/components/ReportUser";
import { Chats } from "../../domain/entities/getChat";
import { onDeleteTrashUser, onGetUserInfoById } from "../../../match/presentation/store/MatchThunk";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../core/store/store";
import { formatDateLastLogged } from "../../../../core/constants/constants";
import { UserInfoProfile } from "../../../match/domain/entities/userInfoProfile";
import { Likes } from "../../../match/domain/entities/userMatch";
import ProfilePreview from "../../../profile/presentation/components/ProfilePreview";
import { deleteChat, deleteSelectedChat } from "../store/ChatSlice";
import { ModalRestricted } from "../components/ModalRestricted";
import { WarningBG } from "../../../../core/icons/Warning";
import { deleteNewMatch } from "../../../match/presentation/store/MatchSlice";
import { useChatStatus } from "../hook/useChatStatus";
import { User } from "../../../../core/icons/User";
import { getMatchLocationParams } from "../../../../core/utilities/locationStorage";
import { formatPublicProfileDistanceText } from "../../../../core/utilities/distance";
import { RemoteImage } from "../../../../core/components/RemoteImage";

export const HeaderChat = ({ navigateBack, selectedChat, currentStatus }: { navigateBack: () => void, selectedChat: Partial<Chats>, currentStatus: string}) => {
    const [isOpenOptions, setIsOpenOptions] = useState<boolean>(false);
    const [actionExecuted, setActionExecuted] = useState(false);
    const [actionNotFound, setActionNotFound] = useState(false);
    const [title, setTitle] = useState("");
    const [text, setText] = useState<JSX.Element>();
    const [icon, setIcon] = useState<JSX.Element>();
    const [isReportUser, setIsReportUser] = useState<boolean>(false);
    const dispatch: AppDispatch = useDispatch();
	const { myNewMatches } = useSelector((state: RootState) => state.match);
    const { user } = useSelector((state: RootState) => state.onboarding);
    const [userInfoProfile, setUserInfoProfile] = useState<Partial<Likes | undefined>>(undefined);
    const [openUserInfoProfile, setOpenUserInfoProfile] = useState<boolean>(false);
    const [status, setStatus] = useState<"leaved" | "blocked" | "deleted" | "">("");
    const [isReportFinished, setIsReportFinished] = useState<boolean>(false);
    const { updateChatStatus } = useChatStatus();
    const [loadingUserInfo, setLoadingUserInfo] = useState(false);
    const [idReport, setIdReport] = useState("");
    const profileSrc = selectedChat.profile_pictures?.[0] ?? "";

    const options = [
        ...((currentStatus === "active" || currentStatus === "matched")
            ? [{
                text: `Report ${selectedChat.username}`,
                onClick: () => { setIsReportFinished(true); setIsOpenOptions(false) ;},
            }]
            : []),
        ...((currentStatus === "active")
            ? [{
                text: "Leave conversation",
                onClick: () =>
                    handleOption(
                        "Leave Conversation",
                        <TextComponent variant="h5">Are you sure that you would like to leave this conversation?</TextComponent>,
                        "leaved",
                        <XCloseBG />
                    ),
            }]
            : []),
        ...(currentStatus === "active"
            ? [{
                text: "Permanently Disconnect",
                onClick: () =>
                    handleOption(
                        "Permanently Disconnect",
                        <TextComponent variant="h5">This action will permanently disconnect you from <span className="text-primary font-bold">{selectedChat.username}</span>. Are you sure you want to proceed?</TextComponent>,
                        "blocked",
                        <XCloseBin />
                    ),
            }]
            : []),
        ...(currentStatus === "banned" || currentStatus === "inactive" || currentStatus === "blocked" || currentStatus === "leaved" || currentStatus === "deleted"
            ? [{
                text: `Delete match`,
                onClick: () =>
                    handleOption(
                        `Delete match`,
                        <TextComponent variant="h5">This action will permanently remove your match with {selectedChat.username}. Are you sure you want to proceed?</TextComponent>,
                        "deleted",
                        <XCloseBin />
                    ),
            }]
            : [])
    ];

    const handleReport = () => {
        if (!selectedChat.user_id) return;
        setIsReportFinished(false);
        setIsReportUser(!isReportUser);
        setIdReport(selectedChat.user_id)
    }

    const handleSuccessReport = () => {
        dispatch(deleteNewMatch((selectedChat.user_id || "")));
        setIdReport("")
        dispatch(deleteSelectedChat());
        updateChatStatus("blocked", selectedChat.chat_id || "", selectedChat.status_user_id1 || "");
    }

    const handleModalClose = () => {
        setTitle("");
        setText(undefined);
        setStatus("");
        setIcon(undefined);
        setActionExecuted(false);
    };

    const handleOption = (optionTitle: string, optionText: JSX.Element,  option: "leaved" | "blocked" | "deleted", newIcon?: JSX.Element) => {
        setTitle(optionTitle);
        setStatus(option);
        setText(optionText);
        setIcon(newIcon)
        setActionExecuted(true);
        setIsOpenOptions(false);
    };

    const handleModalTrue = () => {
        if (status === "" || !selectedChat.chat_id) return;
        if (status === "deleted") {
            dispatch(onDeleteTrashUser(selectedChat.user_id || ""));
            dispatch(deleteNewMatch((selectedChat.user_id || "")));
            dispatch(deleteChat({ chat_id: selectedChat.chat_id }));
            dispatch(deleteSelectedChat());
        } else {
            updateChatStatus(status, selectedChat.chat_id, selectedChat.status_user_id1 || "");
        }
        handleModalClose();
    }

    const handleShowUserProfile = async () => {
        setLoadingUserInfo(true);
        setOpenUserInfoProfile(true);
        let infoUserProfile: Partial<Likes> | undefined = myNewMatches?.find(newMatch => newMatch.user_id === selectedChat.user_id);
        setUserInfoProfile(myNewMatches?.find(newMatch => newMatch.user_id === selectedChat.user_id));
        if (currentStatus === "banned" || currentStatus === "inactive") {
            setActionNotFound(true);
            return;
        }
        if (!infoUserProfile) {
            const result = await dispatch(onGetUserInfoById({
                params : {
                    user_id: selectedChat.user_id || "",
                    ...getMatchLocationParams(),
                }
            }));
            setUserInfoProfile(result.payload as UserInfoProfile);
        }
        setLoadingUserInfo(false);
    }

    
    return (
        <>
            {openUserInfoProfile && 
                <div className="fixed top-0 left-0 z-40 h-screen w-full bg-[#0000006b]">
                    <ProfilePreview
                        pictures={userInfoProfile?.profile_pictures}
                        username={userInfoProfile?.username}
                        verify={userInfoProfile?.verify_status}
                        bio={userInfoProfile?.bio}
                        desires={userInfoProfile?.desires}
                        interest={userInfoProfile?.interests}
                        birth={userInfoProfile?.age}
                        location={userInfoProfile?.city}
                        last_logged_in_time={userInfoProfile?.last_logged_in_time}
                        show_last_logged={userInfoProfile?.show_last_logged}
                        sexual_orientation={userInfoProfile?.sexual_orientation}
                        marital_status={userInfoProfile?.marital_status}
                        gender={userInfoProfile?.gender}
                        distance={formatPublicProfileDistanceText(userInfoProfile?.distance, {
                            country: user?.country,
                            city: user?.city,
                        })}
                        handleProfilePreview={() => setOpenUserInfoProfile(false)}
                        partner={userInfoProfile?.partner}
                        country={userInfoProfile?.country || ""}
                        isBlur={false}
                        loading={loadingUserInfo}
                    />
                </div>
            }
            <Row
                crossAxisAlignment="center"
                className="z-10 sticky gap-2 lg:gap-4 top-0 bg-white p-2.5 lg:px-6 lg:py-3.5 border-b border-b-grayLight"
            >
                <button
                    className="w-10 aspect-square flex items-center justify-center md:hidden text-primary transform rotate-90 rounded-full hover:bg-grayDefault"
                    onClick={navigateBack}
                    aria-label="Back to messages"
                >
                    <ArrowDown2 />
                </button>
                {profileSrc ?
                    <RemoteImage
                        className="w-12 aspect-square object-cover rounded-full cursor-pointer hover:opacity-90 select-none"
                        src={profileSrc}
                        onClick={handleShowUserProfile}
                        draggable={false}
                        alt={`profile-${selectedChat.username}`}
                    />
                    :
                    <User className="cursor-pointer bg-gray-200 p-2 text-white w-12 aspect-square object-cover rounded-full" onClick={handleShowUserProfile} />
                }
                <Row mainAxisAlignment="between">
                    <Column mainAxisAlignment="center">
                        <TextComponent
                            variant="nh5"
                            className="font-semibold"
                        >
                            {selectedChat.username}
                        </TextComponent>
                        {selectedChat.show_last_logged && (
                            <TextComponent
                                variant="nh7"
                                className="text-primary"
                                >
                                {selectedChat.last_logged_in_time && formatDateLastLogged(selectedChat.last_logged_in_time)}
                            </TextComponent>
                        )}
                    </Column>
                    <button
                        onClick={() => setIsOpenOptions(!isOpenOptions)}
                        aria-label="Options"
                    >
                        <Option />
                    </button>
                </Row>
                <DropDown
                    className="absolute right-6 top-[4rem]"
                    condition={isOpenOptions}
                    options={options}
                />
                {actionExecuted && (
                    <ModalSimple
                        title={title}
                        variant={title !== "Report User" ? "secondary" : "primary"}
                        actionExecuted={actionExecuted}
                        onClose={handleModalClose}
                        onAction={handleModalTrue}
                        icon={icon}
                    >
                        {text}
                    </ModalSimple>
                )}
                {isReportFinished && (
                    <ModalSimple
                        title="Finishing the Report"
                        variant="secondary"
                        actionExecuted={isReportFinished}
                        onClose={() => setIsReportFinished(false)}
                        onAction={handleReport}
                        icon={<WarningBG />}
                    >
                        Once you finish this report, you will be permanently disconnected from <span className="text-primary font-bold">{selectedChat.username}</span>. Are you sure you want to proceed?
                    </ModalSimple>
                )}
                <ModalRestricted 
                    userInfoProfile={{ user_id: selectedChat.user_id, username: selectedChat.username, match_id: selectedChat.chat_id } as Likes}
                    action={actionNotFound}
                    category="match"
                    setAction={setActionNotFound}
                />
                {isReportUser &&
                    <ReportUser
                        isOpenReportUser={isReportUser}
                        handleCloseReport={handleReport}
                        handleSuccessReport={handleSuccessReport}
                        username={selectedChat.username}
                        id={idReport}
                        reportedImageUrl={selectedChat.profile_pictures?.[0]}
                    />
                }
            </Row>
        </>
    )
}
